module.exports = __webpack_public_path__ + "franchise-06.png?719ecd39d52674d3e0889955dcd12a2f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/franchise-06.png
// module id = 267
// module chunks = 0